<template>
	<div class="terms-container">
		<div v-html="serviceTermsRead" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	data (){
		return{
			dialog: true,
			prevShowIlustration: false,
			prevShowFooter: false,
		}
	},
	computed:{
		...mapGetters([
			'serviceTermsReadBusy',
			'serviceTermsRead',
			'showIlustration',
			'showFooter',
		]),
	},
	mounted (){
		this.prevShowIlustration = this.showIlustration
		this.prevShowFooter = this.showFooter

		this.$store.commit("showIlustration",false); //hide ilustration
		this.$store.commit("showFooter",false); //hide footer
		this.$store.commit("showLanguages",false); //hide Languages
		this.getServiceTermsRead();
	},
	beforeDestroy (){
		this.prevShowIlustration ? this.$store.commit("showIlustration", true) : null //show ilustration
		this.prevShowFooter ? this.$store.commit("showFooter",true) : null //show footer
		this.$store.commit("showLanguages",true); //show Languages
	},
	methods: {
		getServiceTermsRead () {
			this.$store.dispatch('getServiceTermsRead').then(
			)
		},
	},
	
}
</script>